import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField/index";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { v4 as uuid } from "uuid";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const initialValues = {
  oldPassword: "",
  newPassword: "",
  newPasswordConfirm: "",
};

export default function ChangePassword(props) {
  const { onHide, show } = props;
  const [isError, setIsError] = useState("");
  const [values, setValues] = useState({
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
    showOldPassword: false,
    showNewPassword: false,
    showRePassword: false,
  });
  const handleClickShowPassword = (key) => {
    setValues({ ...values, [key]: !values[key] });
  };

  const ChangeSchema = Yup.object().shape({
    oldPassword: Yup.string()
      .matches(/(?=.*[0-9])(?=.{8,})/, "Password must consist of a number.")
      .required("Old password is required"),
    newPassword: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[0-9])(?=.{8,})/,
        "Password must consist of a letter, a number."
      )
      .required("New password is required"),
    newPasswordConfirm: Yup.string()
      .when("newPassword", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("newPassword")],
          "Both new password need to be the same"
        ),
      })
      .matches(/(?=.*[0-9])(?=.{8,})/, "Password must consist of a number.")
      .required("Confirm password is required"),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const onPostPassword = (values, resetForm, setSubmitting) => {
    const password = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
      newPasswordConfirm: values.newPasswordConfirm,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}user/changePassword`, password, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then(({ data }) => {
        setSubmitting(false);
        resetForm();
        onHide(false);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ChangeSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostPassword(values, resetForm, setSubmitting);
    },
  });

  useEffect(() => {
    setIsError("");
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="changePassword">Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="oldPassword"
                    className="w-100"
                    type={values.showCurrentPassword ? "text" : "password"}
                    label="Current password"
                    error={getInputClasses("oldPassword")}
                    {...formik.getFieldProps("oldPassword")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showCurrentPassword")
                            }
                          >
                            {values.showCurrentPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.oldPassword && formik.errors.oldPassword ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.oldPassword}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="newPassword"
                    className="w-100"
                    type={values.showNewPassword ? "text" : "password"}
                    label="New password"
                    error={getInputClasses("newPassword")}
                    {...formik.getFieldProps("newPassword")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showNewPassword")
                            }
                          >
                            {values.showNewPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.newPassword && formik.errors.newPassword ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.newPassword}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="newPasswordConfirm"
                    className="w-100"
                    type={values.showRePassword ? "text" : "password"}
                    label="Confirm new password"
                    error={getInputClasses("newPasswordConfirm")}
                    {...formik.getFieldProps("newPasswordConfirm")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showRePassword")
                            }
                          >
                            {values.showRePassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.newPasswordConfirm &&
                formik.errors.newPasswordConfirm ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.newPasswordConfirm}
                    </div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false);
              formik.resetForm();
            }}
          >
            Close
          </Button>
          <Button type="submit">Save</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
